import inputData from './inputData/design-request-form';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'design-request-form',
  title: 'Design Request Form',
  description: 'Collect clear, organized design requests so you can deliver new assets efficiently and without back-and-forth.',
  image: '/images/templates/design-request-form.png',
  tags: ['marketing', 'product', 'get-feedback'],
  inputData: inputData,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

